import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { JwtService } from 'src/infrastructure/adapters/services/jwt.service';
import { interval, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthCheckService {
  private router = inject(Router);
  private jwtService = inject(JwtService);
  private checkSubscription: Subscription | null = null;
  
  startTokenExpirationCheck(intervalMs: number = 30000) {
    // Check token expiration every 30 seconds by default
    this.stopTokenExpirationCheck(); // Clear any existing check
    
    this.checkSubscription = interval(intervalMs)
      .pipe(
        filter(() => {
          // Only check if we're not already on auth pages
          const currentUrl = this.router.url;
          return !['/login', '/sign-up', '/recover-password', '/new-password', '/news', '/see-schedules'].includes(currentUrl);
        })
      )
      .subscribe(() => {
        if (this.jwtService.isTokenExpired()) {
          console.log('Token expired during session, redirecting to login');
          this.stopTokenExpirationCheck();
          // Use navigateByUrl with replaceUrl to clear navigation stack
          this.router.navigateByUrl('/login', { replaceUrl: true });
        }
      });
  }
  
  stopTokenExpirationCheck() {
    if (this.checkSubscription) {
      this.checkSubscription.unsubscribe();
      this.checkSubscription = null;
    }
  }
}